import pbfe from "./pbfe.js";
import { _, t } from "./i18n.js";
import createNavbar from "./navbar.js";
import { LANG_URL_MAP, getLang, navigate } from "./index.js";

var container, box;

function init(_container) {
    container = _container;

    box = new pbfe.Flexbox("column");
    box.element.id = "privacyScreen";
    box.element.className = "main-screen";

    // Navbar
    var navbar = createNavbar();
    box.appendChild(navbar);

    // Content Container
    var contentBox = new pbfe.Flexbox("column");
    contentBox.element.id = "privacyContentBox";
    contentBox.alignItems = "center";

    // Breadcrumb
    var breadcrumbContainer = document.createElement("div");
    breadcrumbContainer.className = "breadcrumb-container";

    var breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb";
    breadcrumbContainer.appendChild(breadcrumb);

    var homeLink = document.createElement("a");
    homeLink.className = "breadcrumb-link";
    homeLink.innerHTML = `<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> <span class="breadcrumb-home-text"></span>`;
    t(homeLink.querySelector(".breadcrumb-home-text"), "Home");
    homeLink.addEventListener("click", () => {
        var lang = getLang();
        var prefix = LANG_URL_MAP[lang];
        navigate(prefix ? "/" + prefix : "/");
    });
    breadcrumb.appendChild(homeLink);

    var separator = document.createElement("span");
    separator.className = "breadcrumb-separator";
    separator.innerHTML = `<svg viewBox="0 0 24 24" width="14" height="14" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>`;
    breadcrumb.appendChild(separator);

    var current = document.createElement("span");
    current.className = "breadcrumb-current";
    t(current, "Privacy");
    breadcrumb.appendChild(current);

    contentBox.appendChild(breadcrumbContainer);

    // Title
    var title = document.createElement("h1");
    title.className = "page-title";
    t(title, "Privacy Policy");
    contentBox.appendChild(title);

    // Content card
    var card = document.createElement("div");
    card.className = "about-page-container";
    card.style.textAlign = "left";

    var updated = document.createElement("p");
    updated.className = "legal-updated";
    updated.innerText = "Last updated: August 7, 2026";
    card.appendChild(updated);

    card.insertAdjacentHTML("beforeend", `
        <div class="legal-content">
            <h2>1. Overview</h2>
            <p>Avatar Cropper ("we", "us", or "our") is a free, browser-based tool that lets you crop and edit avatars for social media. This Privacy Policy explains what information we handle, how we use it, and the choices you have. By using avatarcropper.app (the "Site"), you agree to the practices described below.</p>

            <h2>2. How the Tool Works (Local Processing)</h2>
            <p>The core Avatar Cropper experience runs entirely inside your own browser. When you open an image, all cropping, resizing, rotation, and export happen locally on your device using the Canvas API. <strong>Your images are never uploaded to our servers.</strong> We do not transmit, store, or have access to the photos you edit.</p>

            <h2>3. Information We Collect</h2>
            <p>Because image processing is performed on your device, we do not collect the content of the images you edit. We also do not require you to create an account or provide personal information to use the tool.</p>
            <p>Like most websites, we use standard server and analytics technologies that may collect limited, non-identifying information such as approximate location (country/region), device type, browser, language preference, and pages visited. This helps us understand usage and improve the Site.</p>

            <h2>4. Advertising (Google AdSense)</h2>
            <p>We use Google AdSense to display advertisements on the Site. Google AdSense is an advertising service provided by Google LLC ("Google").</p>
            <ul>
                <li>Third-party vendors, including Google, use cookies to serve ads based on a user's prior visits to this and other websites.</li>
                <li>Google's use of advertising cookies enables it and its partners to serve ads to you based on your visit to this Site and/or other sites on the Internet.</li>
                <li>You may opt out of personalized advertising by visiting the <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener">Google Ads Settings</a>, the <a href="https://optout.aboutads.info/" target="_blank" rel="noopener">YourAdChoices</a> page, or by visiting <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener">Google's Advertising Privacy & Terms</a>.</li>
            </ul>
            <p>Under the Google EU User Consent Policy and similar regional requirements, where required (for example in the EEA and UK), we request consent before storing or accessing cookies or other information on your device for advertising and measurement purposes. You can manage your choices at any time through the consent banner shown on the Site.</p>

            <h2>5. Cookies and Similar Technologies</h2>
            <p>Cookies are small text files stored on your device. We and our partners (such as Google) may use cookies to:</p>
            <ul>
                <li>Remember your language preference and improve your experience;</li>
                <li>Measure advertising performance and prevent fraud;</li>
                <li>Serve ads that are more relevant to you (only where permitted by your consent).</li>
            </ul>
            <p>You can control or delete cookies through your browser settings. Disabling certain cookies may affect Site functionality or ad personalization.</p>

            <h2>6. Children's Privacy</h2>
            <p>The Site is not directed to children under the age of 13 (or the equivalent minimum age in your jurisdiction). We do not knowingly collect personal information from children. If you believe a child has provided us with personal data, please contact us so we can remove it.</p>

            <h2>7. Data Security</h2>
            <p>Because your images are processed locally and are not uploaded, they are not exposed to our servers. We follow reasonable technical and organizational measures to protect the limited data we do handle.</p>

            <h2>8. Links to Third-Party Sites</h2>
            <p>The Site may contain links to third-party websites (for example, the social platforms you are cropping avatars for). This Privacy Policy does not apply to those sites, and we are not responsible for their practices.</p>

            <h2>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. When we do, we will revise the "Last updated" date above. We encourage you to review this page periodically.</p>

            <h2>10. Contact Us</h2>
            <p>If you have any questions about this Privacy Policy or our data practices, you can reach us at <a href="mailto:support@avatarcropper.app">support@avatarcropper.app</a>.</p>

            <p class="legal-note">For more information about how Google uses data when you use our Site, visit <a href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener">How Google uses information from sites or apps that use our services</a>.</p>
        </div>
    `);

    contentBox.appendChild({ element: card });
    box.appendChild(contentBox);
}

function show() {
    container.appendChild(box);
    setTimeout(() => box.element.classList.add("show"), 0);
}

function hide() {
    if (!box) return;
    box.element.classList.remove("show");
    if (container && container.contains(box)) {
        container.removeChild(box);
    }
}

var privacyScreen = {
    init, show, hide
};

export default privacyScreen;
